export const app_on_off_enum = [
  true,
  false,
];
